import { FormControl } from '@angular/forms';
import { Component, OnInit, Input, ViewChild, ElementRef, NgZone } from '@angular/core';
import { StoreInformationService } from '@teem/services/store-information.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-branch-modal',
  templateUrl: './branch-modal.component.html',
  styleUrls: ['./branch-modal.component.scss']
})

export class BranchModalComponent implements OnInit {
  showBranchModal = false;
  selectedBranchId: any = null;
  @Input('branches') branches;

  constructor(
    public activeModal: NgbActiveModal,
    private loaderService: LoaderService,
    private storeInformationService: StoreInformationService,
  ) { }


  ngOnInit(): void {
    // 
  }

  confirmBranch() {
    if (!this.selectedBranchId) return;

    this.loaderService.startLoading();
    this.storeInformationService.setReceivingBranch({branch_id: this.selectedBranchId}).subscribe(() => {
      // update UI locally
      this.branches = this.branches.map(b => ({
        ...b,
        receives_online_orders: b.id == this.selectedBranchId ? 1 : 0
      }));

      this.showBranchModal = false;
      this.loaderService.stopLoading();
      Swal.fire(i18n.done, 'Default branch updated successfully', 'success');
      this.activeModal.close({ branches: this.branches });
    });
  }

}
